<template>
	<a-drawer
		v-if="!embedded"
		:header-style="{ fontSize: '18px', fontWeight: 600 }"
		placement="right"
		:closable="false"
		width="600px"
		:visible="visible"
		@close="onClose"
		:body-style="{ padding: 0, overflow: 'hidden' }"
	>
		<template slot="title">
			<div class="drawer-header">{{ title || '聊天记录' }}</div>
		</template>
		<div class="chat-container drawer-chat">
			<div class="chat-messages" ref="chatMessages" @scroll="handleScroll">
				<div class="load-more" v-if="hasMoreMessages" @click="loadMoreMessages">
					<span v-if="!loadingOlder">加载更多消息</span>
					<span v-else>加载中...</span>
				</div>
				<div
					v-for="item in renderMessageList"
					:key="'msg-' + item.id"
					class="message-row"
					:class="{ 'is-anchor-row': isAnchorMessage(item) }"
					:data-message-id="item.id"
				>
						<div class="message-time" v-if="item.showTime">
							<span>{{ item.updatedTime }}</span>
						</div>
						<div
							class="message message-self"
							:class="{ 'is-anchor': isAnchorMessage(item) }"
							:data-message-id="item.id"
							v-if="fromUserInfo.id == item.fromUserId"
						>
							<div class="message-avatar">
								<img :src="item.fromUserAvatarUrl || ''" />
							</div>
							<div class="message-content" v-if="item.type == 'TEXT'">
								<div class="message-bubble">
									<div class="message-text">{{ item.content }}</div>
								</div>
							</div>
							<div class="message-content" v-else-if="item.type == 'PHOTO' || item.type == 'IMAGE'">
								<div class="message-image">
									<x-image :src="getExtraValue(item.extra, 'imageUrl')" :width="200" :height="200" />
								</div>
							</div>
							<div class="message-content" v-else-if="item.type == 'VOICE'">
								<div class="message-bubble">
									<voice-message
										:msg-item="{
											content: getExtraValue(item.extra, 'voiceUrl'),
											duration: getExtraValue(item.extra, 'duration') || 0,
											isRead: 'Y',
										}"
										:is-self="true"
										@read="handleRead"
									/>
								</div>
							</div>
							<div class="message-content" v-else-if="item.type == 'VIDEO'">
								<div class="message-image">
									<video-modal-player
										:video-src="getExtraValue(item.extra, 'videoUrl')"
										:thumbnail="getExtraValue(item.extra, 'coverUrl')"
										video-title="视频"
									/>
								</div>
							</div>
							<div class="message-content" v-else-if="item.type == 'GIFT'">
								<div class="message-image">
									<img :src="getExtraValue(item.extra, 'giftPicUrl')" width="100" height="100" />
								</div>
							</div>
							<div class="message-content" v-else-if="item.type == 'VOLET' || item.type == 'VOLTE'">
								<div class="message-bubble message-bubble-with-icon">
									<a-icon type="phone" class="message-type-icon" />
									<div class="message-text">{{ getCallMessageText(item) }}</div>
								</div>
							</div>
							<div class="message-content" v-else-if="item.type == 'VILET' || item.type == 'VILTE'">
								<div class="message-bubble message-bubble-with-icon">
									<a-icon type="video-camera" class="message-type-icon" />
									<div class="message-text">{{ getCallMessageText(item) }}</div>
								</div>
							</div>
							<span class="message-violation" v-if="isRejected(item)">
								<a-icon type="exclamation-circle" theme="filled" style="color: #ff4d4f;" />
								<span class="audit-fail-tip">{{ getModerationStatusText(item) }}</span>
							</span>
						</div>
						<div
							class="message message-other"
							:class="{ 'is-anchor': isAnchorMessage(item) }"
							:data-message-id="item.id"
							v-else-if="toUserInfo.id == item.fromUserId"
						>
							<div class="message-avatar">
								<img :src="item.fromUserAvatarUrl || ''" />
							</div>
							<div class="message-content" v-if="item.type == 'TEXT'">
								<div class="message-bubble">
									<div class="message-text">{{ item.content }}</div>
								</div>
							</div>
							<div class="message-content" v-else-if="item.type == 'PHOTO' || item.type == 'IMAGE'">
								<div class="message-image">
									<x-image :src="getExtraValue(item.extra, 'imageUrl')" :width="200" :height="200" />
								</div>
							</div>
							<div class="message-content" v-else-if="item.type == 'VOICE'">
								<div class="message-bubble">
									<voice-message
										:msg-item="{
											content: getExtraValue(item.extra, 'voiceUrl'),
											duration: getExtraValue(item.extra, 'duration') || 0,
											isRead: 'Y',
										}"
										:is-self="false"
										@read="handleRead"
									/>
								</div>
							</div>
							<div class="message-content" v-else-if="item.type == 'VIDEO'">
								<div class="message-image">
									<video-modal-player
										:video-src="getExtraValue(item.extra, 'videoUrl')"
										:thumbnail="getExtraValue(item.extra, 'coverUrl')"
										video-title="视频"
									/>
								</div>
							</div>
							<div class="message-content" v-else-if="item.type == 'GIFT'">
								<div class="message-image">
									<img :src="getExtraValue(item.extra, 'giftPicUrl')" width="100" height="100" />
								</div>
							</div>
							<div class="message-content" v-else-if="item.type == 'VILET' || item.type == 'VILTE'">
								<div class="message-bubble message-bubble-with-icon">
									<a-icon type="video-camera" class="message-type-icon" />
									<div class="message-text">{{ getCallMessageText(item) }}</div>
								</div>
							</div>
							<div class="message-content" v-else-if="item.type == 'VOLET' || item.type == 'VOLTE'">
								<div class="message-bubble message-bubble-with-icon">
									<a-icon type="phone" class="message-type-icon" />
									<div class="message-text">{{ getCallMessageText(item) }}</div>
								</div>
							</div>
							<div class="message-violation" v-if="isRejected(item)">
								<a-icon type="exclamation-circle" theme="filled" style="color: #ff4d4f;" />
								<span class="audit-fail-tip">{{ getModerationStatusText(item) }}</span>
							</div>
						</div>
						<div class="system-notice" v-if="item.senderId == 0">
							<span>{{ item.content }}</span>
						</div>
						<div class="system-notice" v-if="isModerationFail(item)">
							<span>快牵：倡导文明交友，请勿发送色情低俗、骚扰辱骂等违反平台规则或违法违规等内容，否则您的账号将会受到相应的处罚</span>
						</div>
					</div>
			</div>
		</div>
	</a-drawer>

	<div v-else class="chat-container embedded-chat">
		<div v-if="loadingMessages" class="chat-loading-mask">
			<a-spin tip="加载会话消息..." />
		</div>
		<div class="chat-messages" ref="chatMessages" @scroll="handleScroll">
			<div class="load-more" v-if="hasMoreMessages" @click="loadMoreMessages">
				<span v-if="!loadingOlder">加载更多消息</span>
				<span v-else>加载中...</span>
			</div>
			<div
				v-for="item in renderMessageList"
				:key="'emb-' + item.id"
				class="message-row"
				:class="{ 'is-anchor-row': isAnchorMessage(item) }"
				:data-message-id="item.id"
			>
					<div class="message-time" v-if="item.showTime">
						<span>{{ item.updatedTime }}</span>
					</div>
					<div
						class="message message-self"
						:class="{ 'is-anchor': isAnchorMessage(item) }"
						:data-message-id="item.id"
						v-if="fromUserInfo.id == item.fromUserId"
					>
						<div class="message-avatar">
							<img :src="item.fromUserAvatarUrl || ''" />
						</div>
						<div class="message-content" v-if="item.type == 'TEXT'">
							<div class="message-bubble">
								<div class="message-text">{{ item.content }}</div>
							</div>
						</div>
						<div class="message-content" v-else-if="item.type == 'PHOTO' || item.type == 'IMAGE'">
							<div class="message-image">
								<x-image :src="getExtraValue(item.extra, 'imageUrl')" :width="200" :height="200" />
							</div>
						</div>
						<div class="message-content" v-else-if="item.type == 'VOICE'">
							<div class="message-bubble">
								<voice-message
									:msg-item="{
										content: getExtraValue(item.extra, 'voiceUrl'),
										duration: getExtraValue(item.extra, 'duration') || 0,
										isRead: 'Y',
									}"
									:is-self="true"
									@read="handleRead"
								/>
							</div>
						</div>
						<div class="message-content" v-else-if="item.type == 'VIDEO'">
							<div class="message-image">
								<video-modal-player
									:video-src="getExtraValue(item.extra, 'videoUrl')"
									:thumbnail="getExtraValue(item.extra, 'coverUrl')"
									video-title="视频"
								/>
							</div>
						</div>
						<div class="message-content" v-else-if="item.type == 'GIFT'">
							<div class="message-image">
								<img :src="getExtraValue(item.extra, 'giftPicUrl')" width="100" height="100" />
							</div>
						</div>
						<div class="message-content" v-else-if="item.type == 'VOLET' || item.type == 'VOLTE'">
							<div class="message-bubble message-bubble-with-icon">
								<a-icon type="phone" class="message-type-icon" />
								<div class="message-text">{{ getCallMessageText(item) }}</div>
							</div>
						</div>
						<div class="message-content" v-else-if="item.type == 'VILET' || item.type == 'VILTE'">
							<div class="message-bubble message-bubble-with-icon">
								<a-icon type="video-camera" class="message-type-icon" />
								<div class="message-text">{{ getCallMessageText(item) }}</div>
							</div>
						</div>
						<span class="message-violation" v-if="isRejected(item)">
							<a-icon type="exclamation-circle" theme="filled" style="color: #ff4d4f;" />
							<span class="audit-fail-tip">{{ getModerationStatusText(item) }}</span>
						</span>
					</div>
					<div
						class="message message-other"
						:class="{ 'is-anchor': isAnchorMessage(item) }"
						:data-message-id="item.id"
						v-else-if="toUserInfo.id == item.fromUserId"
					>
						<div class="message-avatar">
							<img :src="item.fromUserAvatarUrl || ''" />
						</div>
						<div class="message-content" v-if="item.type == 'TEXT'">
							<div class="message-bubble">
								<div class="message-text">{{ item.content }}</div>
							</div>
						</div>
						<div class="message-content" v-else-if="item.type == 'PHOTO' || item.type == 'IMAGE'">
							<div class="message-image">
								<x-image :src="getExtraValue(item.extra, 'imageUrl')" :width="200" :height="200" />
							</div>
						</div>
						<div class="message-content" v-else-if="item.type == 'VOICE'">
							<div class="message-bubble">
								<voice-message
									:msg-item="{
										content: getExtraValue(item.extra, 'voiceUrl'),
										duration: getExtraValue(item.extra, 'duration') || 0,
										isRead: 'Y',
									}"
									:is-self="false"
									@read="handleRead"
								/>
							</div>
						</div>
						<div class="message-content" v-else-if="item.type == 'VIDEO'">
							<div class="message-image">
								<video-modal-player
									:video-src="getExtraValue(item.extra, 'videoUrl')"
									:thumbnail="getExtraValue(item.extra, 'coverUrl')"
									video-title="视频"
								/>
							</div>
						</div>
						<div class="message-content" v-else-if="item.type == 'GIFT'">
							<div class="message-image">
								<img :src="getExtraValue(item.extra, 'giftPicUrl')" width="100" height="100" />
							</div>
						</div>
						<div class="message-content" v-else-if="item.type == 'VILET' || item.type == 'VILTE'">
							<div class="message-bubble message-bubble-with-icon">
								<a-icon type="video-camera" class="message-type-icon" />
								<div class="message-text">{{ getCallMessageText(item) }}</div>
							</div>
						</div>
						<div class="message-content" v-else-if="item.type == 'VOLET' || item.type == 'VOLTE'">
							<div class="message-bubble message-bubble-with-icon">
								<a-icon type="phone" class="message-type-icon" />
								<div class="message-text">{{ getCallMessageText(item) }}</div>
							</div>
						</div>
						<div class="message-violation" v-if="isRejected(item)">
							<a-icon type="exclamation-circle" theme="filled" style="color: #ff4d4f;" />
							<span class="audit-fail-tip">{{ getModerationStatusText(item) }}</span>
						</div>
					</div>
					<div class="system-notice" v-if="item.senderId == 0">
						<span>{{ item.content }}</span>
					</div>
					<div class="system-notice" v-if="isModerationFail(item)">
						<span>快牵：倡导文明交友，请勿发送色情低俗、骚扰辱骂等违反平台规则或违法违规等内容，否则您的账号将会受到相应的处罚</span>
					</div>
				</div>
		</div>
	</div>
</template>

<script>
	import { conversationMessageDetail } from '@/api/op/conversation';
	import XImage from '@/components/XImage.vue';
	import VoiceMessage from '@/components/VoiceMessage.vue';
	import VideoModalPlayer from '@/components/VideoModalPlayer.vue';
	import { formatMessageTime, isOverTimeInterval } from '@/utils/dateTime';

	const PAGE_SIZE = 20;

	export default {
		name: 'ConversationMessageDrawer',
		components: {
			XImage,
			VoiceMessage,
			VideoModalPlayer,
		},
		props: {
			visible: {
				type: Boolean,
				default: false,
			},
			embedded: {
				type: Boolean,
				default: false,
			},
			conversationId: {
				type: [Number, String],
				default: 0,
			},
			fromUserInfo: {
				type: Object,
				default: () => ({ id: null, avatar: '' }),
			},
			toUserInfo: {
				type: Object,
				default: () => ({ id: null, avatar: '' }),
			},
			title: {
				type: String,
				default: '',
			},
			/** 锚定消息 ID：加载时以该消息为会话末尾 */
			anchorMessageId: {
				type: [Number, String],
				default: 0,
			},
			/** 锁定到锚点：不加载比锚点更新的消息，锚点始终为列表最后一条 */
			lockToAnchor: {
				type: Boolean,
				default: false,
			},
		},
		data() {
			return {
				renderMessageList: [],
				loadingMessages: false,
				loadingOlder: false,
				loadingNewer: false,
				hasMoreMessages: false,
				hasMoreAfter: false,
				messagePageIndex: 1,
				useAnchorMode: false,
				ignoreScrollUntil: 0,
				fetchSeq: 0,
			};
		},
		computed: {
			isLockedAnchor() {
				return this.lockToAnchor && Number(this.anchorMessageId) > 0;
			},
		},
		watch: {
			visible(val) {
				if (!this.embedded && val && this.conversationId) {
					this.reloadMessages();
				}
			},
			conversationId(val) {
				if (!val) {
					this.renderMessageList = [];
					this.hasMoreMessages = false;
					this.hasMoreAfter = false;
					this.messagePageIndex = 1;
					return;
				}
				if (this.embedded || this.visible) {
					this.reloadMessages();
				}
			},
			anchorMessageId(val, oldVal) {
				if (!this.embedded && !this.visible) return;
				if (!this.conversationId) return;
				if (Number(val) > 0 && Number(val) !== Number(oldVal)) {
					this.reloadMessages();
				}
			},
		},
		mounted() {
			if (this.embedded && this.conversationId) {
				this.reloadMessages();
			}
		},
		methods: {
			onClose() {
				this.$emit('update:visible', false);
				this.$emit('close');
			},
			reloadMessages() {
				this.messagePageIndex = 1;
				this.hasMoreMessages = false;
				this.hasMoreAfter = false;
				this.renderMessageList = [];
				this.useAnchorMode = Number(this.anchorMessageId) > 0;
				this.ignoreScrollUntil = 0;
				this.fetchMessages();
			},
			isAnchorMessage(item) {
				return Number(this.anchorMessageId) > 0 && Number(item.id) === Number(this.anchorMessageId);
			},
			lockedAnchorId() {
				return Number(this.anchorMessageId) || 0;
			},
			/** 按 id 升序去重；可选裁剪到锚点（首屏/向上加载时用） */
			normalizeMessageList(list, clipToAnchor = false) {
				let rows = Array.isArray(list) ? list.slice() : [];
				const anchorId = this.lockedAnchorId();
				if (clipToAnchor && this.isLockedAnchor && anchorId > 0) {
					rows = rows.filter((m) => Number(m.id) > 0 && Number(m.id) <= anchorId);
				}
				rows.sort((a, b) => Number(a.id) - Number(b.id));
				const seen = {};
				const unique = [];
				rows.forEach((item) => {
					const id = Number(item && item.id);
					if (!id || seen[id]) return;
					seen[id] = true;
					unique.push(item);
				});
				return unique;
			},
			applyHasMoreFlag(data, loadedCount) {
				if (data && typeof data.hasMore === 'boolean') {
					this.hasMoreMessages = data.hasMore;
				} else if (data && typeof data.has_more === 'boolean') {
					this.hasMoreMessages = data.has_more;
				} else {
					this.hasMoreMessages = loadedCount >= PAGE_SIZE;
				}
			},
			applyListResponse(data) {
				const rawList = (data && data.messageList) || [];
				// 首屏裁剪到锚点，保证点击消息为末条
				const messageList = this.normalizeMessageList(rawList, true);
				this.renderMessageList = this.processedMessages(messageList);
				this.applyHasMoreFlag(data, messageList.length);
				// 是否还有比当前末条更新的消息（向下滚动可继续加载）
				if (data && typeof data.hasMoreAfter === 'boolean') {
					this.hasMoreAfter = data.hasMoreAfter;
				} else if (data && typeof data.has_more_after === 'boolean') {
					this.hasMoreAfter = data.has_more_after;
				} else if (this.isLockedAnchor && this.lockedAnchorId() > 0) {
					// 接口未返回时，锁定模式下先假定可能有更新，由向下加载探测
					this.hasMoreAfter = true;
				} else {
					this.hasMoreAfter = false;
				}
				return messageList;
			},
			getModerationStatus(item) {
				if (item.sendStatus == 'FAIL') {
					return 'FAILED';
				}
				return item.moderationStatus || '';
			},
			/** 需展示审核状态文案：待审核 / 拒绝 / 失败 */
			needModerationTip(item) {
				const status = this.getModerationStatus(item);
				return status === 'PENDING' || status === 'REJECTED' || status === 'FAILED';
			},
			/** 审核不通过（用于违规提示条） */
			isModerationFail(item) {
				const status = this.getModerationStatus(item);
				return status === 'REJECTED' || status === 'FAILED';
			},
			getModerationStatusText(item) {
				const map = {
					PENDING: '待审核',
					REJECTED: '未通过审核',
					FAILED: '审核失败',
				};
				return map[this.getModerationStatus(item)] || '';
			},
			isRejected(item) {
				return this.needModerationTip(item);
			},
			parseExtra(extra) {
				if (extra == null || String(extra).trim() === '') return {};
				if (typeof extra === 'object' && !Array.isArray(extra)) return extra;
				try {
					const parsed = JSON.parse(extra);
					return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : {};
				} catch (e) {
					return {};
				}
			},
			getExtraValue(extra, key) {
				const obj = this.parseExtra(extra);
				const val = obj[key];
				return val == null ? '' : val;
			},
			formatCallDuration(seconds) {
				const sec = Number(seconds);
				if (!Number.isFinite(sec) || sec <= 0) return '';
				const mins = Math.floor(sec / 60);
				const secs = Math.floor(sec % 60);
				return `${mins}:${String(secs).padStart(2, '0')}`;
			},
			getHangupText(hangup) {
				const map = {
					1: '被叫拒绝',
					2: '被叫未接听',
					3: '主叫取消',
					4: '金币不足挂断',
					5: '违规中断',
				};
				return map[Number(hangup)] || '';
			},
			getCallMessageText(item) {
				const type = item.type || '';
				const label = type === 'VILET' || type === 'VILTE' ? '视频通话' : '语音通话';
				const durationText = this.formatCallDuration(this.getExtraValue(item.extra, 'callLen'));
				if (durationText) {
					return `${label} ${durationText}`;
				}
				const hangupText = this.getHangupText(this.getExtraValue(item.extra, 'hangup'));
				return hangupText ? `${label} ${hangupText}` : label;
			},
			getMessageIds() {
				return this.renderMessageList.map((m) => Number(m.id)).filter((id) => id > 0);
			},
			mergeUniqueMessages(frontList, backList) {
				const seen = {};
				const merged = [];
				[...(frontList || []), ...(backList || [])].forEach((item) => {
					const id = Number(item && item.id);
					if (!id || seen[id]) return;
					seen[id] = true;
					merged.push(item);
				});
				return merged;
			},
			processedMessages(messages) {
				if (!Array.isArray(messages)) return [];
				return messages.map((message, index) => {
					const extra =
						message.extra != null && typeof message.extra === 'object' && !Array.isArray(message.extra)
							? message.extra
							: this.parseExtra(message.extra);
					const currentTime = message.updateTime;
					const prevTime = index > 0 ? messages[index - 1].updateTime : null;
					const showTime =
						index === 0 || (prevTime && isOverTimeInterval(currentTime, prevTime, 15));
					return {
						...message,
						extra,
						updatedTime: formatMessageTime(currentTime),
						showTime,
					};
				});
			},
			recomputeShowTime(list) {
				return list.map((message, index) => {
					const currentTime = message.updateTime;
					const prevTime = index > 0 ? list[index - 1].updateTime : null;
					return {
						...message,
						showTime: index === 0 || (prevTime && isOverTimeInterval(currentTime, prevTime, 15)),
					};
				});
			},
			buildDetailParams(extra = {}) {
				const params = {
					conversationId: this.conversationId,
					...extra,
				};
				if (
					this.useAnchorMode &&
					Number(this.anchorMessageId) > 0 &&
					!params.beforeMessageId &&
					!params.afterMessageId
				) {
					params.anchorMessageId = this.anchorMessageId;
				} else if (!this.useAnchorMode && !params.page) {
					params.page = this.messagePageIndex;
				}
				return params;
			},
			async fetchMessages() {
				if (!this.conversationId) return;
				const seq = ++this.fetchSeq;
				this.loadingMessages = true;
				this.renderMessageList = [];
				try {
					const anchorId = Number(this.anchorMessageId) || 0;
					this.useAnchorMode = anchorId > 0;

					const params = {
						conversationId: this.conversationId,
					};
					if (this.useAnchorMode) {
						// 取 id <= 点击消息：末条即为点击消息
						params.anchorMessageId = anchorId;
						params.beforeMessageId = anchorId + 1;
					} else {
						params.page = this.messagePageIndex || 1;
					}

					const res = await conversationMessageDetail(params);
					if (seq !== this.fetchSeq) return;
					this.applyListResponse(res.data);

					this.ignoreScrollUntil = Date.now() + 600;
					await this.$nextTick();
					if (seq !== this.fetchSeq) return;
					this.scrollToBottom();

					// 消息少、撑不满一屏时无法下滚，需自动把锚点之后的消息补出来
					await this.fillNewerIfCannotScroll(seq);
					if (seq !== this.fetchSeq) return;
					await this.$nextTick();
					this.scrollToAnchorOrBottom();
				} catch (e) {
					if (seq !== this.fetchSeq) return;
					console.error('获取聊天记录失败:', e);
					this.$message.error('获取聊天记录失败');
				} finally {
					if (seq === this.fetchSeq) {
						this.loadingMessages = false;
						this.$nextTick(() => this.scrollToAnchorOrBottom());
					}
				}
			},
			/** 内容撑不满、无法继续下滚时，自动加载锚点之后的消息 */
			async fillNewerIfCannotScroll(seq) {
				let guard = 0;
				while (this.hasMoreAfter && guard++ < 20) {
					if (seq != null && seq !== this.fetchSeq) return;
					await this.$nextTick();
					const container = this.$refs.chatMessages;
					if (!container) break;
					const canScrollDown = container.scrollHeight > container.clientHeight + 40;
					if (canScrollDown) break;

					const beforeLen = this.renderMessageList.length;
					await this.loadNewerMessages();
					if (this.renderMessageList.length <= beforeLen) break;
				}
			},
			handleRead() {},
			scrollToBottom() {
				this.$nextTick(() => {
					const container = this.$refs.chatMessages;
					if (!container) return;
					this.ignoreScrollUntil = Date.now() + 400;
					container.style.scrollBehavior = 'auto';
					container.scrollTop = container.scrollHeight;
				});
			},
			/** 滚到点击的锚点消息（其后若有更新消息，可继续下滚查看） */
			scrollToAnchorOrBottom() {
				this.$nextTick(() => {
					const container = this.$refs.chatMessages;
					if (!container) return;
					this.ignoreScrollUntil = Date.now() + 400;
					const anchorId = this.lockedAnchorId();
					const el = anchorId
						? container.querySelector(`[data-message-id="${anchorId}"]`)
						: null;
					container.style.scrollBehavior = 'auto';
					if (el) {
						const target = el.offsetTop - container.clientHeight + el.offsetHeight + 24;
						container.scrollTop = Math.max(target, 0);
						const delta =
							el.getBoundingClientRect().bottom -
							container.getBoundingClientRect().bottom +
							12;
						container.scrollTop += delta;
					} else {
						container.scrollTop = container.scrollHeight;
					}
				});
			},
			handleScroll() {
				if (this.ignoreScrollUntil && Date.now() < this.ignoreScrollUntil) {
					return;
				}
				const container = this.$refs.chatMessages;
				if (!container) return;

				// 滚到接近底部时，加载比当前更新的消息
				if (
					this.hasMoreAfter &&
					!this.loadingNewer &&
					!this.loadingOlder &&
					!this.loadingMessages
				) {
					const remain = container.scrollHeight - container.scrollTop - container.clientHeight;
					if (remain <= 80) {
						this.loadNewerMessages();
					}
				}
			},
			async loadMoreMessages() {
				if (this.loadingOlder || this.loadingMessages || !this.hasMoreMessages) return;
				this.loadingOlder = true;
				try {
					const container = this.$refs.chatMessages;
					const scrollHeight = container ? container.scrollHeight : 0;
					const ids = this.getMessageIds();
					const prevMinId = ids.length ? Math.min.apply(null, ids) : 0;

					if (!prevMinId) {
						this.hasMoreMessages = false;
						return;
					}

					const params = {
						beforeMessageId: prevMinId,
					};

					const res = await conversationMessageDetail(this.buildDetailParams(params));
					if (res && res.isSucceed === false) {
						return;
					}

					const list = this.normalizeMessageList((res.data && res.data.messageList) || [], true);
					const existingIds = {};
					this.getMessageIds().forEach((id) => {
						existingIds[id] = true;
					});
					const uniqueList = list.filter((item) => {
						const id = Number(item && item.id);
						return id > 0 && !existingIds[id];
					});

					this.applyHasMoreFlag(res.data, uniqueList.length || list.length);

					if (!uniqueList.length) {
						this.hasMoreMessages = false;
						return;
					}

					this.renderMessageList = this.recomputeShowTime(
						this.processedMessages(
							this.normalizeMessageList(
								this.mergeUniqueMessages(uniqueList, this.renderMessageList),
								false
							)
						)
					);
					await this.$nextTick();
					if (container) {
						this.ignoreScrollUntil = Date.now() + 300;
						container.style.scrollBehavior = 'auto';
						container.scrollTop = Math.max(container.scrollHeight - scrollHeight, 0);
					}
				} catch (e) {
					console.error('加载更多消息失败:', e);
				} finally {
					this.loadingOlder = false;
				}
			},
			async loadNewerMessages() {
				if (this.loadingNewer || !this.hasMoreAfter) return;
				const ids = this.getMessageIds();
				const maxId = ids.length ? Math.max.apply(null, ids) : 0;
				if (!maxId) {
					this.hasMoreAfter = false;
					return;
				}

				this.loadingNewer = true;
				try {
					const res = await conversationMessageDetail(
						this.buildDetailParams({ afterMessageId: maxId })
					);
					if (res && res.isSucceed === false) {
						return;
					}
					const list = this.normalizeMessageList((res.data && res.data.messageList) || [], false);
					if (res.data && typeof res.data.hasMoreAfter === 'boolean') {
						this.hasMoreAfter = res.data.hasMoreAfter;
					} else if (res.data && typeof res.data.has_more_after === 'boolean') {
						this.hasMoreAfter = res.data.has_more_after;
					} else {
						this.hasMoreAfter = list.length >= PAGE_SIZE;
					}

					const existingIds = {};
					this.getMessageIds().forEach((id) => {
						existingIds[id] = true;
					});
					const uniqueList = list.filter((item) => {
						const id = Number(item && item.id);
						return id > 0 && !existingIds[id];
					});
					if (!uniqueList.length) {
						this.hasMoreAfter = false;
						return;
					}
					this.renderMessageList = this.recomputeShowTime(
						this.processedMessages(
							this.normalizeMessageList(
								this.mergeUniqueMessages(this.renderMessageList, uniqueList),
								false
							)
						)
					);
				} catch (e) {
					console.error('加载更新消息失败:', e);
				} finally {
					this.loadingNewer = false;
				}
			},
		},
	};
</script>

<style lang="less" scoped>
	.chat-container {
		height: 100%;
		display: flex;
		flex-direction: column;
	}
	.drawer-chat {
		height: calc(100vh - 60px);
	}
	.embedded-chat {
		height: 100%;
		min-height: 0;
		position: relative;
	}
	.chat-loading-mask {
		position: absolute;
		inset: 0;
		z-index: 5;
		display: flex;
		align-items: center;
		justify-content: center;
		background: rgba(245, 246, 247, 0.72);
	}
	.chat-messages {
		height: 100%;
		overflow-y: auto;
		flex: 1;
		padding: 16px;
		background: #f5f6f7;
		scrollbar-color: #1890ff #bae7ff;
		scrollbar-width: thin;
		position: relative;
	}
	.load-more {
		cursor: pointer;
		text-align: center;
		color: #4078f2;
		padding: 8px 0;
		font-size: 13px;
	}
	.message-row {
		width: 100%;
	}
	.message-row.is-anchor-row {
		animation: anchor-flash 1.2s ease;
	}
	.message {
		display: flex;
		margin-bottom: 20px;
		align-items: center;
	}
	.message-self {
		flex-direction: row-reverse;
	}
	.message.is-anchor .message-bubble {
		box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.55);
	}
	.message.is-anchor .message-image {
		box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.55);
		border-radius: 4px;
	}
	.message.is-anchor {
		animation: anchor-flash 1.2s ease;
	}
	@keyframes anchor-flash {
		0% { background: rgba(24, 144, 255, 0.18); }
		100% { background: transparent; }
	}
	.message-avatar {
		width: 40px;
		height: 40px;
		border-radius: 50%;
		overflow: hidden;
		flex-shrink: 0;
	}
	.message-avatar img {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}
	.message-self .message-avatar {
		margin-left: 12px;
	}
	.message-self .message-violation {
		margin-right: 10px;
	}
	.message-other .message-avatar {
		margin-right: 12px;
	}
	.message-other .message-violation {
		margin-left: 10px;
	}
	.message-violation {
		display: inline-flex;
		align-items: center;
		gap: 4px;
		flex-shrink: 0;
		line-height: 1;
		font-size: 16px;
		align-self: center;
		white-space: nowrap;
	}
	.message-content {
		max-width: 70%;
	}
	.message-bubble {
		padding: 12px 16px;
		border-radius: 4px;
		position: relative;
		box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
	}
	.message-self .message-bubble {
		border-radius: 18px;
		background: #95ec69;
		border-top-right-radius: 4px;
	}
	.message-other .message-bubble {
		background: white;
		color: #1f2329;
		border-radius: 18px;
		border-top-left-radius: 4px;
	}
	.message-text {
		line-height: 1.5;
		word-break: break-word;
	}
	.message-bubble-with-icon {
		display: flex;
		align-items: center;
		gap: 8px;
	}
	.message-bubble-with-icon .message-type-icon {
		flex-shrink: 0;
		font-size: 16px;
		color: rgba(0, 0, 0, 0.45);
	}
	.message-self .message-bubble-with-icon .message-type-icon {
		color: rgba(0, 0, 0, 0.5);
	}
	.message-image {
		max-width: 250px;
		border-radius: 4px;
		overflow: hidden;
		cursor: pointer;
	}
	.message-time {
		font-size: 12px;
		color: #86909c;
		margin-top: 4px;
		margin-bottom: 10px;
		text-align: center;
	}
	.system-notice {
		text-align: center;
		margin: 10px 0;
	}
	.system-notice span {
		display: inline-block;
		background-color: #fff8e6;
		color: #d48806;
		padding: 6px 15px;
		border-radius: 15px;
		font-size: 12px;
	}
	.audit-fail-tip {
		color: #ff4d4f;
		font-size: 12px;
		line-height: 1.2;
	}
	.drawer-header {
		font-size: 18px;
		font-weight: 600;
		position: fixed;
		top: 0;
		right: 0;
		width: 600px;
		z-index: 100;
		background: white;
		border-bottom: 1px solid #f0f0f0;
		padding: 16px 24px;
		margin-bottom: 0;
	}
	::v-deep .ant-drawer-wrapper-body {
		overflow-y: hidden;
	}
	::v-deep .ant-drawer-header {
		padding: 27px 24px;
	}
</style>
